import { Link } from "react-router-dom/cjs/react-router-dom.min"
import "./About.css"
import { APP_DIRECTORY } from "../SystemVariables"


const About = () => {
    return (
    <div className="about">
        <h1>Soundboard1</h1>
        <div className="description">
            <p>An application developed by Modularity AS, a Norwegian registered IT company.</p>
            <p>We hope you enjoy it!</p>
        </div>
        <div className="contact">
            <h2>Contact</h2>
            Please email us at <a href="mailto:contact@modularity.no">contact@modularity.no</a> for any questions, suggestions, or bug reports!
        </div>
        <div className="privacy">
            <h2>Privacy Policy</h2>
            You can find a link to our privacy policy <a href="https://privacy.soundboard1.com">here</a>.
        </div>
        <Link to={`${APP_DIRECTORY}/`}><div className="btn btn-primary">To Dashboard</div></Link>
    </div>)
}

export default About
